import React from "react"
import { useGetKYCStatus } from "@poolzfinance/api4"
import VerifyButton from "./VerifyButton"
import { useAccountStatus } from "state/application/hooks"
import { EAccountStatus } from "models/enums/EAccountStatus"

export default function KYC({
  setAccountApproved,
  showSmallButton
}: {
  readonly setAccountApproved?: React.Dispatch<React.SetStateAction<boolean>>
  readonly showSmallButton?: boolean
}) {
  // "incomplete" | "waiting" | "inreview" | "approved" | "rejected" | "blocked"
  const { loading, error, data: checkRefId } = useGetKYCStatus()
  const { dispatch, colorStatus, textStatus, accountStatus } = useAccountStatus()

  React.useEffect(() => {
    if (loading) dispatch(EAccountStatus.Checking)
    else if (error) dispatch(EAccountStatus.NotVerified)
    else if (checkRefId) {
      const status = checkRefId.myProxyKYC.Status
      if (!status) dispatch(EAccountStatus.NotVerified)
      else if (status === "checking") dispatch(EAccountStatus.Checking)
      else if (status === "approved") {
        dispatch(EAccountStatus.Verified)
        setAccountApproved && setAccountApproved(true)
      } else if (~["incomplete", "rejected", "blocked"].indexOf(status ?? "")) dispatch(EAccountStatus.NotVerified)
      else dispatch(EAccountStatus.Processing)
    }
  }, [loading, error, checkRefId, dispatch, setAccountApproved])

  return (
    <div className="flex flex-col gap-5">
      <div className="flex bg-[#f6f6f7] box-border rounded-md items-center h-10 w-full text-xs justify-between">
        <div className="px-3">
          <span className="font-black pr-2">Account Status</span>
          <span className="text-gray-400 px-2 border-l-2 border-l-slate-300" style={{ color: colorStatus }}>
            {textStatus}
          </span>
        </div>

        {showSmallButton && accountStatus === EAccountStatus.NotVerified && (
          <VerifyButton className="select-none bg-black rounded-md text-white px-3 py-2 mr-2">Verify</VerifyButton>
        )}
        <div className={`w-[7px] h-[7px] rounded-full mr-3`} style={{ backgroundColor: colorStatus }} />
      </div>
      {!showSmallButton && accountStatus === EAccountStatus.NotVerified && (
        <VerifyButton className="select-none p-3 rounded-md bg-gradient-to-r from-[#0666EA] to-[#FB71AE] text-[#FDFDFD] text-sm focus:outline-0 disabled:from-gray-500 disabled:to-gray-500 disabled:text-[#2A2839] text-center hover:to-[#0666EA]">
          Verify your identity
        </VerifyButton>
      )}
    </div>
  )
}
